import axios from 'axios'

export default {
    get: () => axios.get('currencies'),
    getGlobal: () => axios.get('currencies/global'),
    store: (data) => axios.post('currencies/store', data),
    update: (data) => axios.put('currencies/'+data.id, data),
    delete: (id) => axios.delete('currencies/'+id, )
}